(() => {
  
    // Add to script only once
    window.Xpansion = window.Xpansion || {};
    if (window.Xpansion.connectorReady) {
        return;
    }
    window.Xpansion.connectorReady = true;

    window.Xpansion.bgMatch = function (element, color) {
        let defaultStyle = 'rgba(0, 0, 0, 0)';
    
        let backgroundColor = window.getComputedStyle(element).backgroundColor;
        if (backgroundColor !== defaultStyle) return backgroundColor === color;
    
        if (!element.parentElement) return false;
        return Xpansion.bgMatch(element.parentElement, color);
    };

    if (!document.querySelector('.syk-x-product-connector')) {
        return;
    }

    function imgURL(src, size, attr) {
        return src.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
            return '_' + size + (attr ? '_' + attr : '') + match;
        });
    }

    function isFunctionDefined() {
        return typeof window.Swiper !== 'undefined';
    }

    // // Check if Swiper is loaded to page before executing code
    // if (!isFunctionDefined('Swiper')) {
    //     let intervalScript = setInterval(checkSwiperScript, 50);

    //     function checkSwiperScript() {
    //         if (isFunctionDefined('Swiper')) {
    //             clearInterval(intervalScript);
    //             init();
    //         }
    //     }
    // } else {
    //     init();
    // }
    init();

    function init() {
        document
            .querySelectorAll('.syk-x-product-connector:not(.syk-x-product-connector-initialized)')
            .forEach(function (banner) {
              console.log(banner);
                banner.classList.add('syk-x-product-connector-initialized');
                /*if (
                    Xpansion.bgMatch(
                        banner.parentElement,
                        window.getComputedStyle(banner.querySelector('.syk-x-product-connector-container'))
                            .backgroundColor
                    )
                ) {
                    banner.querySelector('.syk-x-product-connector-container').classList.add('syk-x-no-padding');
                }*/

                const productConnect = banner.dataset.productsconnect;
                if (productConnect === 'list') {
                    // initializeSliders(banner);
                    handleDropdown();
                    return;
                }
                const imageFill = banner.dataset.imagefill;
                const imageWidth = Math.round(banner.dataset.imagewidth * 1.5);
                const imageHeight = Math.round(banner.dataset.imageheight * 1.5);
                const productID = parseInt(banner.dataset.productid);
                const productConnectCode = banner.dataset.productcode;
                const productTitle = banner.dataset.producttitle;
                const productShow = banner.dataset.productshow;
                let codePart;
                let query;
                let field;
                let variant;
                let title;
                let mainContent;
                let html;
                if (productConnectCode) {
                    codePart = productConnectCode.split('-');
                    query = codePart[0].trim();
                    field = 'variants.' + productConnect;
                } else {
                    query = productTitle;
                    field = 'title';
                }
                if (!query) {
                    if (Shopify.designMode) {
                        // initializeSliders(banner);
                    } else {
                        banner.remove();
                    }
                    return;
                }
                fetch(
                    window.Shopify.routes.root +
                        'search/suggest.json?q=' +
                        encodeURIComponent(query) +
                        '&resources[type]=product&resources[options][fields]=' +
                        encodeURIComponent(field)
                )
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(response.status);
                        }
                        return response.json();
                    })
                    .then((json) => {
                        console.log(json.resources.results.products.length)
                        if (json.resources.results.products.length <= 1) {
                            if (Shopify.designMode) {
                                // initializeSliders(banner);
                            } else {
                                banner.remove();
                            }
                            return;
                        }

                        Array.from(banner.getElementsByClassName('placeholders')).forEach(function (el) {
                            el.remove();
                        });
                        const sortedProducts = json.resources.results.products;
                        Array.from(sortedProducts).forEach(function (product) {
                            let show = true;
                            if (
                                product.id === productID ||
                                (field === 'title' && product.title.startsWith(query) === false)
                            ) {
                                show = false;
                            }
                            if (!show) {
                                return;
                            }
                            if (product.variants[0] && product.variants[0].title != 'Default Title') {
                                variant = product.variants[0];
                            } else {
                                variant = product;
                            }
                            if (field === 'title') {
                                title = variant.title.replace(query, '');
                            } else {
                                title = variant.title;
                            }
                          
                          /* START MAATWERK */
                          if (banner.dataset.generic_title) {
                            title = variant.title.replace(banner.dataset.generic_title, '');
                          }
                          /* END MAATWERK */
                          
                            if (variant.featured_image.url != null) {
                                let img = document.createElement('img');
                                let crop = 'pad_fff';
                                if (imageFill === 'true') {
                                    crop = 'crop_center';
                                }
                                img.src = imgURL(variant.featured_image.url, imageWidth + 'x' + imageHeight, crop);
                                img.height = imageHeight;
                                img.width = imageWidth;
                                img.alt = title;
                                mainContent = img.outerHTML;
                            } else {
                                mainContent =
                                    '<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"></path><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"></path><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"></path><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"></path></svg>';
                            }

                            let productClass = variant.featured_image.url === null ? ' no-img' : '';
                            product.id != productID ? '' : (productClass += ' current-product');

                            html = `<div class="swiper-slide ${productClass}" data-title="${title}"><div><a href="${variant.url}">${mainContent}</div></a><span class="syk-x-product-connector-title">${title}</span></div>`;
                            banner.querySelector('.swiper-wrapper').innerHTML += html;
                        });
                        // initializeSliders(banner);
                    })
                    .catch((error) => {
                        this.close();
                        throw error;
                    });
            });
    }

    function handleDropdown() {
      document.querySelectorAll('.syk-x-product-connector select').forEach((option) => {
        option.addEventListener('change', function() {
          var selectElement = this;
          setTimeout(function(token) {
            var selectedOption = selectElement.options[selectElement.selectedIndex];
            var targetUrl = selectedOption.getAttribute('data-url');
            var currentUrl = option.dataset.url;
            if (targetUrl && targetUrl != currentUrl) {
              window.location.href = targetUrl;
            }
          }, 1); 
        });

      });
      
    };
    // function initializeSliders(banner) {
    //     // Get products per row setting
    //     let productRow = banner.dataset.productsrow;
    //     const sortProducts = banner.dataset.productssort;
    //     const visibleProductsMobile = banner.dataset.visibleproductsmobile;
    //     let products = banner.querySelectorAll('.swiper-slide');
    //     const toggleButton = banner.querySelector('.syk-x-product-connector-toggle');

    //     function comparator(a, b) {
    //         return a.dataset['title'].localeCompare(b.dataset['title']);
    //     }
    //     if (sortProducts != 'manual') {
    //         const slides = banner.querySelectorAll('.swiper-slide[data-title]');
    //         const slidesArray = Array.from(slides);
    //         let sorted = slidesArray.sort(comparator);
    //         if (sortProducts == 'alphabetically-desc') {
    //             sorted = sorted.reverse();
    //         }
    //         sorted.forEach((e) => banner.querySelector('.swiper-wrapper').appendChild(e));
    //     }
    //     products = banner.querySelectorAll('.swiper-slide:not(.placeholder-hidden)');
    //     if (banner.getElementsByClassName('current-product').length > 0) {
    //         banner
    //             .getElementsByClassName('current-product')[0]
    //             .parentNode.insertBefore(
    //                 banner.getElementsByClassName('current-product')[0],
    //                 banner.getElementsByClassName('swiper-slide')[0]
    //             );
    //     }

    //     if (toggleButton && products.length > visibleProductsMobile) {
    //         toggleButton.classList.remove('syk-x-product-connector-toggle-hidden');
    //         if (!banner.querySelector('.swiper-slide.syk-x-product-connector-product-hidden')) {
    //             toggleProducts(products, visibleProductsMobile);
    //         }
    //         toggleButton.addEventListener('click', function () {
    //             toggleButton.classList.toggle('syk-x-product-connector-button-toggled');
    //             toggleButton.querySelectorAll('span').forEach(function (span) {
    //                 span.classList.toggle('syk-x-product-connector-toggle-hidden');
    //             });
    //             if (
    //                 toggleButton
    //                     .querySelector('span.syk-x-product-connector-toggle-hidden')
    //                     .getAttribute('data-toggle') == 'less'
    //             ) {
    //                 banner.scrollIntoView();
    //             }
    //             toggleProducts(products, visibleProductsMobile);
    //         });
    //     }

    //     // Initiate slider
    //     const swiper = new Swiper(banner.querySelector('.swiper'), {
    //         direction: 'horizontal',
    //         slidesPerView: productRow,
    //         spaceBetween: 16,
    //         loop: false,
    //         updateOnWindowResize: true,
    //         breakpointsBase: 'container',
    //         touchStartPreventDefault: false,
    //         navigation: {
    //             nextEl: banner.querySelector('.swiper-button-next'),
    //             prevEl: banner.querySelector('.swiper-button-prev'),
    //         },
    //         breakpoints: {
    //             0: {
    //                 spaceBetween: 10,
    //                 simulateTouch: false,
    //                 allowTouchMove: false,
    //             },
    //             767: {
    //                 slidesPerView: productRow,
    //                 spaceBetween: 20,
    //             },
    //         },
    //         on: {
    //             afterInit: (swiper) => {
    //                 banner.classList.add('syk-x-product-connector-loaded');
    //                 swiper.update();
    //                 continueSliderFunctions();
    //             },
    //             slideChange: (swiper) => {
    //                 banner.classList.toggle('syk-x-product-connector-btn-prev-disabled', swiper.isBeginning);
    //                 banner.classList.toggle('syk-x-product-connector-btn-next-disabled', swiper.isEnd);
    //             },
    //         },
    //     });

    //     function continueSliderFunctions() {
    //         // Product title
    //         banner.querySelectorAll('.swiper-slide').forEach(function (el, index) {
    //             if (banner.querySelector('.syk-x-product-connector-title-main') != null) {
    //                 if (index == 0) {
    //                     banner.querySelector('.syk-x-product-connector-title-main').innerText = el.querySelector(
    //                         '.syk-x-product-connector-title'
    //                     ).innerText;
    //                 }
    //             }
    //             el.addEventListener('mouseenter', function (event) {
    //                 banner.classList.remove('init');
    //                 if (banner.querySelector('.syk-x-product-connector-title-main') != null) {
    //                     banner.querySelector('.syk-x-product-connector-title-main').innerText =
    //                         event.target.querySelector('.syk-x-product-connector-title').innerText;
    //                 }
    //             });
    //         });

    //         // Custom buttons
    //         banner.querySelectorAll('.syk-x-product-connector-button').forEach((el) =>
    //             el.addEventListener('click', function () {
    //                 if (el.dataset.button === 'next') {
    //                     banner.querySelector('.swiper-button-next').click();
    //                 } else {
    //                     banner.querySelector('.swiper-button-prev').click();
    //                 }
    //             })
    //         );

    //         // Check navigation buttons
    //         if (banner.querySelectorAll('.swiper-button-lock').length > 0) {
    //             banner.classList.add('syk-x-product-connector-buttons-disabled');
    //         } else {
    //             banner.classList.add('syk-x-product-connector-buttons-enabled');
    //         }
    //     }
    // }

    function toggleProducts(products, visibleProductsMobile) {
        products.forEach(function (element, index) {
            if (index >= visibleProductsMobile) {
                element.classList.toggle('syk-x-product-connector-product-hidden');
            }
        });
    }
})();
